export default __webpack_public_path__ + "media/zurb/img/legacy/icons/notable/pro-influence-1a6377abe28413630fb782d75c5b1251.png";